module.exports = __webpack_public_path__ + "static/media/SquarePaymentGateway.b2c5b49f.pdf";